import styled from 'styled-components';
import { removeOfferById, removeShopById, saveOffer, saveShop } from '../../../../lib/user';
import LayoutCollectionView from '../LayoutCollectionView/LayoutCollectionView';
import { OFFERS } from '../../../../lib/constants';

const PAGE_CONTEXT = 'my-zone-with-favs';

const WelcomeTextDiv = styled.div`
  ${({ theme }) => theme.typographyRebrand.body.lg}
  color: ${({ theme }) => theme.c.text.primary};
  margin: ${p => p.theme.unit(6)} 0;
`;

const DesktopWelcomeTextDiv = styled(WelcomeTextDiv)``;

const MobileWelcomeTextDiv = styled(WelcomeTextDiv)``;

const MyZoneWithFavs = (props) => {
  const {
    itemsData = [],
    favItemIds = {},
    pageStateModifiers,
    userData = {},
    itemType,
    locale,
    CompToUse,
    slug,
    viewType,
    tags,
    helloPrefixText,
    yourItemsHelpText,
    isMobile,
  } = props;

  const WelcomeTextDivToUse = isMobile ? MobileWelcomeTextDiv : DesktopWelcomeTextDiv;
  const { visitInfo = {} } = userData;
  const { firstName = '' } = visitInfo;

  let saveItemHandler = saveShop;
  let removeItemHandler = removeShopById;
  if (itemType === OFFERS) {
    saveItemHandler = saveOffer;
    removeItemHandler = removeOfferById;
  }

  return (
    <div>
      {/* Welcome Text*/}
      {firstName && (
        <WelcomeTextDivToUse>
          {`${helloPrefixText}${firstName}. ${yourItemsHelpText}`}
        </WelcomeTextDivToUse>
      )}

      {/* Shops */}
      <LayoutCollectionView
        favItemIds={favItemIds}
        items={itemsData}
        Comp={CompToUse}
        itemType={itemType}
        tags={tags}
        slug={slug}
        viewType={viewType}
        saveItemHandler={saveItemHandler}
        removeItemHandler={removeItemHandler}
        pageStateModifiers={pageStateModifiers}
        pageContext={PAGE_CONTEXT}
        locale={locale} />
    </div>
  );
};

export default MyZoneWithFavs;
